import React, { Component } from 'react';
import { Body, Header, Wrapper, FooterBar } from '../postStyles'
import JournalInfo from '../JournalInfo'

class BeingBelongingJournal extends Component {
    render() {
        return (
            <Wrapper>
                <Header>
                    <img src="https://i.ibb.co/3C1D0X9/portrait.jpg" alt="cover"/>
                    <div className="info">
                        <h1>
                            to be & to belong.
                        </h1>
                        <div className="date">11/12/2021</div>
                    </div>
                </Header>
                <Body>
                    <div className="paragraph">
                    Some years ago I stumbled across a quote on Pinterest, <i>I hate people generally, 
                    but I like people individually.</i> Judging by the multitude of times it showed up 
                    on my feed, a decent number of people must have resonated with it to some degree. 
                    I found the juxtaposition to be amusing, yet an opposite sentiment resonated with me instead. 
                    I am resonably fascinated by the idea of human beings — on its broad term. but I find 
                    myself harboring some kind of bitterness towards individuals more than I prefer to admit.
                    In the words of <a href="https://www.sarahwilson.com/" target='_blank' rel='noreferrer'>Sarah Wilson</a>
                    , <i>"I love humanity, I just find real-life human hard."</i>
                    </div>
                    <div className="paragraph">
                    In truth, I'm often more delighted by the concept of human beings 
                    than by their close-up and tactile details. An excerpt stood out to me from a 
                    <a href='https://ava.substack.com/p/writing-as-autonomy' target='_blank' rel='noreferrer'> newsletter </a>
                    that I recently subscribed to. <i>"The only thing that did and does feel real to me is people 
                    and their suffering and their joy, our deep and ongoing need for connection".</i> I thought — 
                    <i>I feel the same way</i>. I am constantly reminded of the amorphous depth that exists within another 
                    human, how a thousand strangers around me resemble a thousand kaleidoscopic constellations 
                    of unparalleled perspectives and untold narratives. I dwell among the fragments of our shared 
                    experience — recorded in the form of novels and films and essays that overflow with honesty — 
                    which, at the end of the day, leave me wide-eyed before the curious and inevitable experience 
                    that it is to be human. What fickle and detestable and resolute and heartening creatures that 
                    we are. If all else is rendered to be an illusion then this is what remains real.
                    </div>
                    <div className="paragraph">
                    At the same time, I often felt weary from social interactions . For most of my adolescence, 
                    I have been so hindered by my insecurities that I could barely see past it to perceive what 
                    actually matters. At heart I enjoyed meeting new people but social anxiety often felt like a more 
                    overpowering force. The fear of being judged and dismissed spilled over into quietness and shyness — a facet 
                    of my persona I never wanted to take ownership of because it spoke so intimately to my vulnerability. 
                    </div>
                    <div className="paragraph">
                    At one point in time I came to conclude that somehow, my ability to form social connection 
                    with others must be defective. It all seems somewhat melodramatic from a distance away, 
                    but at the time, the gravity of it all felt tangibly real. In order to be worthy of connection, 
                    I felt as though I needed to be extroverted and at ease. I was not. I felt and noticed too 
                    much to carry an air of nonchalence. I was the awkward teen, treading upon invisible eggshells 
                    and carrying my over-sensitivities with a lack of grace. 
                    </div>
                    <div className="paragraph">
                    In Present over Perfect, Shauna Niequist described how she felt as though she was perceiving 
                    everything through a lens of rejection. <i>"When anyone opens their mouth to say anything at all, 
                    all I could hear is you are not good enough,"</i> she writes, precisely describing what resonates 
                    with me at an awkwardly private level. <i>You are not good enough</i> — everything became its echo. 
                    I did not dare second guessing because it felt like something unquestionable encoded into my 
                    narrative. Shame was my default and every interaction became a reinforcement of a belief that 
                    was never true. 
                    </div>
                    <div className="paragraph">
                    So all along, I have been the author of my own rejection. A barren field sprawled across 
                    the landscape within and I thought that the acceptance and affection of others were 
                    the only flowers that could possibly take residence. If I were to unclench, I would 
                    discover that the seeds were all held within my still-clammy palms. Instead, I built 
                    walls to conceal that ever existed a field at all.
                    </div>
                    <img src="https://i.ibb.co/BtKCxSG/01.png" alt="rejection 01"/>
                    <div className="paragraph">
                    During a heated conversation with my boyfriend, I found myself tempted to withdraw. 
                    The chasm of difference between us was what drew me into the relationship in the very 
                    beginning, wide-eyed with curiosity at the potentiality that intimacy could contain. 
                    But in the moment, that chasm felt like an alienating barrier. <i>We are so different.</i> 
                    I think while biting my lips. But I do not love another merely for the reflection 
                    of myself that I see in the other. But this nebulous in-between of our differences 
                    is what stretches and grows me — making it all worthwhile.
                    </div>
                    <div className="paragraph">
                    Still all of a sudden I wanted to run the other way, letting the familar wave of shame 
                    wash over myself, believing once again that <i>see — I was right about it after all. I do 
                    not deserve to belong so intimately with another. If I never allow myself to draw near 
                    then I do not have to experience the inevitable disappointment of it all. </i>
                    </div>
                    <div className="paragraph">
                    In the wake of it I wonder — How do I dismantle these walls that I have sought safety 
                    within? It will not be an overnight process, but it will be worthwhile. I am learning 
                    to give myself the permission to draw near to belonging, showing up raw and fragmented 
                    and nevertheless worthy.
                    </div>
                    <img src="https://i.ibb.co/6v4Yb7W/02.png" alt="rejection 02"/>
                    <div className="paragraph">
                    Gradually in the past year, these long-held tensions began to dissolve. I no longer 
                    feel as fearful in conversations and appear to be much more at ease with my own skin. 
                    The nervousness in my breath started to subside. My desire to be among others finally 
                    surpassing my fear of rejection.All of it unfolded like a sprout that 
                    has been struggling to bloom. On a seemingly ordinary spring day, sunlight permeated 
                    in and at last, the blossom emerges — like a long-awaited epiphany. 
                    </div>
                    <div className="paragraph">
                    Perhaps it was something of a coming-of-age miracle, the insecurities that I carried 
                    were but characteristic of adolescence. Perhaps it has to do with the social isolation 
                    of the past year's pandemic, bringing the core need of connection and belonging into 
                    open exposure. Suddenly everyone was voicing the same longing that I have always felt 
                    pulsing beneath the surface of my skin. In this communal loneliness, I suddently felt 
                    less alone. 
                    </div>
                    <div className="paragraph">
                    Perhaps it was the very gift within solitude that I have been invited into — both the 
                    place I desired to outrun from and where I unearthed my strength — learning to be at 
                    home within myself so I could be at ease among others. This process of distentangling 
                    and reconciling is somewhere I continue to abide.
                    </div>
                    <img src="https://i.ibb.co/X2ZVDqS/03.png" alt="rejection 02"/>
                    <div className="paragraph">
                    I have believed that the reason this desperation to belong resided so vividly within me is because 
                    of an inherent inadequacy that I carried. I thought that this ache must have meant that 
                    I was broken — but it only meant that I am human, wired for connection and belonging. 
                    At the end of the day, with all shiny persona and saturated timelines aside, we are all 
                    rhythmed to a similar ache. We are merely fickle and detestable and resolute and heartening 
                    creatures navigating through this curious and inevitable shared experience of life. 
                    All of us, together in our solitude.
                    </div>
                    <div className="paragraph">
                    Another thing to mention is that, on occasions, I continue to feel a lingering disappointment 
                    for every abruptly ended conversation and carry around small inklings of grief for each 
                    acquaintance that I have lost in touch with. People are constantly coming and going. 
                    The silhouettes that knit the landscape around us are in a state of constant motion and 
                    sometimes the brevity of it all pains me. 
                    </div>
                    <div className="paragraph">
                    Perhaps the disappointment that I experience is defined in equal magnitude by my expectation, 
                    from where I begin to view another person as a means to an end instead of as an end to 
                    themselves. I wish to instead send a <a href="https://kunleidoscopic.wordpress.com/2020/06/13/a-love-letter-to-the-passengers/"
                    target='_blank' rel='noreferrer'>love letter to the passengers </a>— to somehow let them know 
                    that despite the ephemerality of our interaction and the ambiguous depth of our bond, 
                    I am grateful that at one moment in time, we had belonged together. And all of this is 
                    infathomably bigger than you and I. Any fragment of warmth will outlive our temporary 
                    interaction and dissolve as an escalating ripple. 
                    </div>
                    <div className="paragraph">
                    For now, this is what I know to be true — I desire for nothing more than genuine smiles 
                    and candid conversations. I desire for nothing less but to dive beneath the surface 
                    and towards the nebulous ocean of our collective experience. I want to hold intent eye 
                    contact and ask sincere questions. I want to stand alongside you and feel empathy 
                    pulsing through us. I want to hold space for your story and be left in awe by how 
                    wildly different and terrifyingly similar that we are — you may never walk an inch 
                    in my shoes but you know my tears and joys and my longing to belong, as intimately 
                    as I know yours.
                    </div>
                    <div className="paragraph">
                    I am leaning into the chaos within, so I could see past the projection of my own 
                    insecurities and release the weight of expectations in order to perceive what actually 
                    matters. And all of this feels like liberation — sincerity at last.
                    </div>
                </Body>
                <FooterBar 
                next={JournalInfo['founddocumentary']}
                previous={JournalInfo['asurvivalguidefortheseason']}/>
            </Wrapper>
        )
    }
}

export default BeingBelongingJournal